export const getIds = globalState => globalState.ids.ids;
export const getNextPageParams = globalState => globalState.ids.paginationParams;
